import {createContext} from "react";
let BOContext = createContext();
export default BOContext;